/** Wire-version constants; safe to import without loading document schemas. */
export const QUESTION_CONTENT_FORMAT_VERSION = 1 as const;
export const QUESTION_CONTENT_VERSION_HEADER =
  'X-Question-Content-Version' as const;
export const QUESTION_CONTENT_VERSION_HEADER_VALUE = String(
  QUESTION_CONTENT_FORMAT_VERSION
);
export const QUESTION_CONTENT_UPDATE_REQUIRED_CODE =
  'QUESTION_CONTENT_UPDATE_REQUIRED' as const;
